import React, { useState } from 'react';
import * as API from 'utils/api';

import { Modal } from 'antd';
import { ArrowsAltOutlined, ShrinkOutlined, DownloadOutlined } from '@ant-design/icons';
import { ModalLoading } from 'components/Modal/ModalLoading';

import './modalPdf.scss';
import { notifyApiError } from 'utils/notification';

const ModalPdf = ({ path, close, expand, download, fileInfo }) => {
  const [expandPdf, setExpandPdf] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleExpandToggle = () => {
    setExpandPdf(prevState => !prevState);
  };

  const handleDownload = async () => {
    try {
      setLoading(true);
      await API.downloadDocumentMarketing({ url: path, nameDocument: fileInfo?.document_name || fileInfo?.name || '' });
    } catch (e) {
      notifyApiError(e);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      visible={true}
      onCancel={close}
      footer={null}
      centered={true}
      closable={true}
      // width={550}
      className={`modalPdf ${expandPdf ? 'modalPdf_full' : ''}`}>
      {loading && <ModalLoading />}

      {download && (
        <div className="modalPdf_icon modalPdf_download" onClick={handleDownload}>
          <DownloadOutlined />
        </div>
      )}
      {expand && (
        <div className="modalPdf_icon modalPdf_expand" onClick={handleExpandToggle}>
          {expandPdf ? <ShrinkOutlined /> : <ArrowsAltOutlined />}
        </div>
      )}

      <div className="pdf-container" style={{ height: expandPdf ? '80vh' : '800px' }}>
        {Array.isArray(path) ? (
          path.map((item, index) => (
            <iframe
              key={index}
              src={item}
              title="PDF Viewer"
              width="100%"
              height="100%"
              style={{ border: 'none' }}
            />
          ))
        ) : (
          <iframe
            src={path}
            title="PDF Viewer"
            width="100%"
            height="100%"
            style={{ border: 'none' }}
          />
        )}
      </div>
    </Modal>
  );
};

export default ModalPdf;
